import { useTranslation } from 'react-i18next';
import type { Measure, MeasureMetadata } from '../../../../api/work-periods-client/work-periods-client.type';
import { FilterItem } from '../../../../components/filters/filter-item';
import { formatMeasureName } from '../../process-analysis.helpers';

type Props = {
  measure: MeasureMetadata;
  isSelected: boolean;
  isSelectedTrends?: boolean;
  showTrends: boolean;
  selectedMeasuresCount: number;
  maxSelectedMeasures?: number;
  onMeasureToggle: (measure: Measure) => void;
  onTrendsToggle?: (measure: Measure) => void;
};

export const MeasureItem = ({
  measure,
  isSelected,
  isSelectedTrends = false,
  showTrends,
  selectedMeasuresCount,
  maxSelectedMeasures,
  onMeasureToggle,
  onTrendsToggle,
}: Props) => {
  const { t } = useTranslation();
  const handleToggle = (value: string) => {
    onMeasureToggle(value as Measure);
  };

  const handleTrendsToggle = (value: string) => {
    if (onTrendsToggle) {
      onTrendsToggle(value as Measure);
    }
  };

  return (
    <FilterItem
      value={measure.measure_name}
      label={formatMeasureName(measure.measure_name, t)}
      description={measure.measure_description}
      isSelected={isSelected}
      isSelectedTrends={isSelectedTrends}
      showTrends={showTrends}
      selectedCount={selectedMeasuresCount}
      maxSelected={maxSelectedMeasures}
      onToggle={handleToggle}
      onTrendsToggle={handleTrendsToggle}
    />
  );
};
